import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "door-fit-finder-selection__wrapper" }
const _hoisted_2 = { class: "door-fit-finder-selection__text" }
const _hoisted_3 = { class: "door-fit-finder-selection__header" }
const _hoisted_4 = { class: "door-fit-finder-selection__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SwitchToggle = _resolveComponent("SwitchToggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, { icon: ['fa-thin', 'fa-puzzle'] }),
      _createElementVNode("h6", _hoisted_3, _toDisplayString($props.displayName), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.description), 1 /* TEXT */)
    ]),
    _createVNode(_component_SwitchToggle, {
      isSelected: $props.isSelected,
      onOnSwitchChange: $options.onSwitchChange,
      id: "doorFitFinderToggle"
    }, null, 8 /* PROPS */, ["isSelected", "onOnSwitchChange"])
  ]))
}